/* IMPORT */
import { OBSERVER, setObserver } from '../context.js';
import { isFunction } from '../utils.js';
function untrack(fn) {
    if (isFunction(fn)) {
        const observerPrev = OBSERVER;
        if (observerPrev) {
            try {
                setObserver(undefined);
                return fn();
            }
            finally {
                setObserver(observerPrev);
            }
        }
        else {
            return fn();
        }
    }
    else {
        return fn;
    }
}
/* EXPORT */
export default untrack;
